import React, { Component } from 'react';
import { PulseLoader } from 'react-spinners';
import { graphql, compose } from 'react-apollo';
import MetaTags from 'react-meta-tags';
import { withAlert } from 'react-alert';
import { resetPassword } from '../../../queries';
import RFLogo from '../../../assets/images/logo.png';

import {
  Container,
  Wrapper,
  Header,
  Logo,
  Content,
  Button,
} from './styles';
import { Label, Input } from '../../../assets/styles';
import colors from '../../../assets/colors';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      token: '',
      password: '',
      confirmPassword: '',
      emailSend: '',
      passwordError: false,
      passwordFocus: false,
      confirmPasswordError: false,
      confirmPasswordFocus: false,
      confirmPasswordInvalid: false,
      loading: false,
    };
  }

  componentDidMount = () => {
    document.getElementById('html').style.overflowY = 'hidden';

    const params = new URLSearchParams(this.props.location.search);
    const email = params.get('email');
    const token = params.get('token');

    if (email !== null && token !== null) {
      this.props.history.push('/reset_password');
      this.setState({ email, token });
    } else {
      this.props.history.push('/login');
    }
  }

  handleSubmit = async () => {
    await this.validateInputs();

    const {
      email,
      token,
      password,
      passwordError,
      confirmPasswordError,
    } = this.state;

    if (!passwordError && !confirmPasswordError) {
      this.setState({ loading: true, emailSend: email });

      this.props
        .resetPassword({
          variables: {
            email,
            token,
            password,
          },
        })
        .then(() => {
          this.setState({ loading: false });
          this.props.alert.success('Sua senha foi redefinida com sucesso');
        })
        .catch((err) => {
          const { emailSend } = this.state;

          this.setState({ loading: false });

          if (/email/i.test(err.message)) this.props.alert.error(`Nenhuma conta vinculada ao endereço de e-mail "${emailSend}" foi encontrada`);
          if (/invalid/i.test(err.message)) this.props.alert.error('O seu token é invalido');
          if (/expired/i.test(err.message)) this.props.alert.error('Seu pedido de redefinição de senha expirou');
        });
    }
  }

  validateInputs = () => {
    const {
      password, confirmPassword,
    } = this.state;

    this.setState({
      passwordError: false,
      confirmPasswordError: false,
      confirmPasswordInvalid: false,
    });

    if (password.length < 6) this.setState({ passwordError: true });
    if (confirmPassword.length === 0) this.setState({ confirmPasswordError: true });
    if (password !== confirmPassword) {
      this.setState({ confirmPasswordError: true, confirmPasswordInvalid: true });
    }
  }

  handleInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  onFocus = (type) => {
    this.setState({ [type]: true });
  }

  onBlur = (type) => {
    this.setState({ [type]: false });
  }

  render() {
    const {
      email,
      passwordError,
      passwordFocus,
      loading,
      confirmPasswordError,
      confirmPasswordFocus,
      confirmPasswordInvalid,
    } = this.state;

    return (
      <div>
        {email.length !== 0 ? (
          <MetaTags>
            <title>Redefinir senha</title>
            <meta name="robots" content="noindex" />
          </MetaTags>
        ) : null}
        <Header>
          <Container>
            <Logo src={RFLogo} alt="Logo do Reforma Fácil" onClick={() => this.props.history.push('/login')} />
          </Container>
        </Header>
        <Wrapper>
          <Content>
            <h1>Redefinir senha</h1>
            <p className="subtitle">Sua nova senha deve conter no mínimo 6 caracteres</p>
            <form>
              <Label>
                <p className="fieldName">Nova senha</p>
                <Input
                  type="password"
                  name="password"
                  error={passwordError}
                  onFocusInput={passwordFocus}
                  onChange={this.handleInputChange}
                  onFocus={() => this.onFocus('passwordFocus')}
                  onBlur={() => this.onBlur('passwordFocus')}
                />
                {passwordError ? (
                  <p className="inputMessage errorMessage">A senha deve conter no mínimo 6 caracteres</p>
                ) : null}
              </Label>
              <Label>
                <p className="fieldName">Confirmar nova senha</p>
                <Input
                  type="password"
                  name="confirmPassword"
                  error={confirmPasswordError}
                  onFocusInput={confirmPasswordFocus}
                  onChange={this.handleInputChange}
                  onFocus={() => this.onFocus('confirmPasswordFocus')}
                  onBlur={() => this.onBlur('confirmPasswordFocus')}
                />
                {confirmPasswordInvalid ? (
                  <p className="inputMessage errorMessage">As senhas não correspondem</p>
                ) : null}
              </Label>
            </form>
            <Button type="submit" disabled={loading} onClick={this.handleSubmit}>
              {!loading ? (
                <span>Continuar</span>
              ) : (
                <PulseLoader
                  sizeUnit="px"
                  size={7}
                  color={colors.white}
                  loading={loading}
                />
              )}
            </Button>
          </Content>
        </Wrapper>
      </div>
    );
  }
}

export default compose(
  withAlert(),
  graphql(resetPassword, { name: 'resetPassword' }),
)(ResetPassword);
